import { productionCountriesOptions } from "@/dentlab/src/lib/constants/productionCountries";
import { CustomSelectShadcn } from "../../../components/custom-select-shadcn.component";
import { SelectProps } from "../../form-types";

export const ProdCountryChoiceSelect: React.FC<SelectProps> = (props) => {
	return (
		<CustomSelectShadcn
			options={productionCountriesOptions}
			inputLabel="Fertigung"
			value={props.value}
			onChange={(value) => props.onChange(value?.toString() || null)}
			disabled={props.disabled}
			densitySize={props.densitySize}
			inputHeight={props.inputHeight}
			width={props.width}
			required={props.required}
			validationError={props.validationError}
		/>
	);
};
